import React from 'react';

import AudioInputList from './AudioInputList/AudioInputList';
import AudioOutputList from './AudioOutputList/AudioOutputList';
import {
  DialogContent,
  Typography,
  Divider,
  Dialog,
  DialogActions,
  Button,
  Theme,
  DialogTitle,
  Hidden,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import VideoInputList from './VideoInputList/VideoInputList';
import MaxGalleryViewParticipants from './MaxGalleryViewParticipants/MaxGalleryViewParticipants';
import BackgroundSelectionDialog from '../BackgroundSelectionDialog/BackgroundSelectionDialog';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { useAppState } from '../../state/index';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: '600px',
    minHeight: '400px',
    [theme.breakpoints.down('xs')]: {
      width: 'calc(100vw - 32px)',
    },
    '& .inputSelect': {
      width: 'calc(100% - 35px)',
    },
  },
  button: {
    float: 'right',
  },
  backgroundButton: {
    marginBottom: '1em',
  },
  paper: {
    [theme.breakpoints.down('xs')]: {
      margin: '16px',
    },
  },
  headline: {
    marginBottom: '1.3em',
    fontSize: '1.1rem',
  },
  listSection: {
    margin: '2em 0 0.8em',
    '&:first-child': {
      margin: '1em 0 2em 0',
    },
  },

  joinButtonsWhiteLabelCustomColor: {
    backgroundColor: '#191949',
    '&:hover': {
      backgroundColor: '#111133',
    },
  },

  joinButtonsOCCustomColor: {
    backgroundColor: '#EF6C22',
    '&:hover': {
      backgroundColor: '#FE6013',
    },
  },
}));

export default function DeviceSelectionDialog({
  colorStyle,
  open,
  onClose,
}: {
  colorStyle?: string;
  open: boolean;
  onClose: () => void;
}) {
  const classes = useStyles();

  const { setIsBackgroundSelectionOpen } = useVideoContext();
  const { typeUserPatient } = useAppState();

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.paper }}>
      <DialogTitle>Configurações de áudio e vídeo</DialogTitle>
      <Divider />
      <DialogContent className={classes.container}>
        <div className={classes.listSection}>
          <Typography variant="h6" className={classes.headline}>
            Vídeo
          </Typography>
          {!typeUserPatient && (
            <>
              <Button
                color="primary"
                variant="contained"
                onClick={() => setIsBackgroundSelectionOpen(true)}
                className={`${classes.backgroundButton} `}
              >
                Escolher fundo
              </Button>
              <BackgroundSelectionDialog />
            </>
          )}
          <VideoInputList />
        </div>
        <Divider />
        <div className={classes.listSection}>
          <Typography variant="h6" className={classes.headline}>
            Áudio
          </Typography>
          <AudioInputList />
        </div>
        <div className={classes.listSection}>
          <AudioOutputList />
        </div>
        <Hidden smDown>
          <Divider />
          <div className={classes.listSection}>
            <Typography variant="h6" className={classes.headline}>
              Visualização de Galeria
            </Typography>
            <MaxGalleryViewParticipants />
          </div>
        </Hidden>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          color="primary"
          variant="contained"
          className={`${classes.button} ${colorStyle === 'cuidodevc' &&
            classes.joinButtonsWhiteLabelCustomColor} ${colorStyle === 'oc' && classes.joinButtonsOCCustomColor}`}
          onClick={onClose}
        >
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
